import { Component, AfterViewInit } from '@angular/core';
import { LayoutService } from 'portalempresa';
import { Router, NavigationEnd } from '@angular/router';
import { AppAlertService } from '@services';
import { environment } from '../environments/environment';
import { AuthService } from './core/security/services/auth/auth.service';
import { version } from '../../package.json';
import * as Prism from 'prismjs';
import { ApiDutConfiguration } from '@core/api-dut/api-dut-configuration';
import { ApiSeopConfiguration } from '@core/api-seop/api-seop-configuration';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['../app.component.css'],
})
export class AppComponent implements AfterViewInit {
	public customLayout: boolean;
	public environment: any;
	public version: string = version;
	public title: string;

	constructor(
		public _appAlertService: AppAlertService,
		private authService: AuthService,
		private layoutService: LayoutService,
		private apiDutConfig: ApiDutConfiguration,
		private apiSeopConfig: ApiSeopConfiguration
	) {
		this.title = '';
		this.environment = environment;
		this.appendGaTrackingCode();
		this.setInit();
		this.appendGaTrackingCode();
	}

	private appendGaTrackingCode() {
		if (environment.googleAnalyticsKey) {
			try {
				const script = document.createElement('script');
				script.innerHTML =
					`
                  (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
                  (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
                  m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
                  })(window,document,'script','https://www.google-analytics.com/analytics.js','ga');
                  ga('create', '` +
					environment.googleAnalyticsKey +
					`', 'auto');
                `;
				document.head.appendChild(script);
			} catch (ex) {
				console.error('Error appending google analytics');
				console.error(ex);
			}
		}
	}

	/**
	 * @method ngAfterViewInit
	 */
	ngAfterViewInit() {
		Prism.highlightAll();
	}

	setInit() {
		this.layoutService.isCustomLayout.subscribe((value: boolean) => {
			this.customLayout = value;
		});
		this.authService.initialize();
		this.setApisConfig();
	}

	onAlertClosed(dismissedAlert: any): void {
		this._appAlertService.close(dismissedAlert);
	}

	get usuarioLogueado$() {
		return this.authService.isAuthenticatedObs;
	}

	setApisConfig(): void {
		this.apiDutConfig.rootUrl = environment.api_dut_url;
		this.apiSeopConfig.rootUrl = environment.api_seop_url;
	}
}
